import { ToastOptions } from 'react-toastify';

export const toastConfig: ToastOptions = {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    style: { textAlign: 'left' }
};

export enum CrudType {
    Create = 'CREATE',
    Edit = 'EDIT'
}

export enum TourType {
    UNCE = 'UNCE',
    UNSE = 'UNSE',
    UACE = 'UACE',
    PVVE = 'PVVE'
}

export enum TourIsRunning {
    nextUserWithEnterprise = 'nextUserWithEnterprise',
    prevUserWithEnterprise = 'prevUserWithEnterprise',
    nextPVVE = 'nextPVVE',
    prevPVVE = 'prevPVVE'
}
